<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>
   <smr-stylist-picker
     [stylistID]="stylistID"
     [readOnly]="readOnlyStylistPicker"
     [showAllStaff]="true"
     (onInit)="onStylistPickerInit($event)"
     (stylistSelect)="onStylistSelect($event)"
     cssClass="smr-stylist-picker-for-prebookingreport">
   </smr-stylist-picker>
  </ion-toolbar>
  <ion-toolbar>
   <salonmonster-date-picker
     [startDate]="startDate"
     [endDate]="endDate"
     [disabled]="isLoading"
     (rangeChanged)="rangeChanged($event)"
   ></salonmonster-date-picker>
 </ion-toolbar>
</ion-header>

<ion-content>

  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStats" (click)="onTapToReload()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStats">


    <ion-row>
      <ion-col class="hidden-lg-down" size="2"></ion-col>
      <ion-col size="12" size-xl="8">
        <div style="height: 50vh;">
          <canvas baseChart
                  [data]="pieChartData"
                  [type]="pieChartType"
                  [options]="pieChartOptions">
          </canvas>
        </div>
        <div>
          <p class="text-align-center" *ngIf="pieChartData.datasets[0].data[0] > 80">
            You're rocking it.
          </p>
          <p class="text-align-center" *ngIf="pieChartData.datasets[0].data[0] > 70 && pieChartData.datasets[0].data[0] <= 80">
            Excellent, just turn it up a notch.
          </p>
          <p class="text-align-center" *ngIf="pieChartData.datasets[0].data[0] > 60 && pieChartData.datasets[0].data[0] <= 70">
            Nice job, keep going.
          </p>
          <p class="text-align-center" *ngIf="pieChartData.datasets[0].data[0] <= 60">
            Room to grow
          </p>
        </div>
      </ion-col>
      <ion-col class="hidden-lg-down" size="2"></ion-col>
    </ion-row>

    <p-table styleClass="sticky-table" [columns]="cols" [value]="stats" sortMode="multiple" [responsive]="true">
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: right">
          <span class="export">Export to:</span>
          <ion-button
            fill="outline"
            (click)="exportExcel()"
            style="margin-right: 0.5em"
          >Excel</ion-button>
          <ion-button
            fill="outline"
            (click)="exportPdf()"
          >
          PDF
          </ion-button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            <div [ngClass]="{'text-align-center': col.field !=='timestamp'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td [ngClass]="{'center-numbers-table-wider-padding': col.field !=='timestamp'}" *ngFor="let col of columns">
            <!--span class="ui-column-title">{{ col.header }}</!--span-->
            {{col.field === "total" ?  (stat[col.field] | salonMonsterCurrency): (stat[col.field])}} <span *ngIf="col.field === 'preBookedPercentage'">%</span>
          </td>

        </tr>

      </ng-template>
    </p-table>
  </ng-container>

</ion-content>

